import $http from '../http';
let complaintPath = '/tio/complain/v2/api/';
// 督办
export const superviseList = data => {
  return $http({
      url: complaintPath + 'supervise/superviseList',
      data,
      method: 'POST'
  });
};

// 关注
export const attentionList = data => {
  return $http({
      url: complaintPath + 'supervise/attentionList',
      data,
      method: 'POST'
  });
};

export default {
  superviseList,
  attentionList
};
